export class Claim {
    constructor(
        public RawDataImport_ShardClaimIdentifier: number,
        public Prescription_PrescriptionNumber: string,
        public Prescription_FillDate: Date,
        public Prescription_SoldDate: Date,
        public Prescription_SplitBillCode: number,
        public Location_NCPDPProviderIdentifier: string,
        public Location_NationalProviderIdentifier: string,
        public Location_CorporateLocationNumber: string,
        public Payer_ProcessorIdentifier: string,
        public Payer_ShardPayerName: string,
        public Payer_ShardPayerGroupIdentifier: number,
        public Payer_PlanCode: string,
        public Payer_PlanName: string,
        public AREngine_TransactionCode: string,
        public Money_TransactionPriceClaim: number,
        public Money_CoPayAmountClaim: number,
        public Money_PayerReceivableAmountClaim: number,
        public Money_OpenAmountClaim: number,
        public AREngine_PostSystemDate: Date,
        public HasAuditHistory: boolean,
        public IsRelatedItem: boolean) {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/claim.model.ts